import type { PlanningTodoAgentItem } from '@buildautomaton/types';

export async function submitPlanningTodosForTurn(params: {
  sessionId: string;
  turnId: string;
  items: PlanningTodoAgentItem[];
  cloudApiBaseUrl: string;
  getCloudAccessToken: () => string;
}): Promise<{ ok: true } | { ok: false; error: string }> {
  const token = params.getCloudAccessToken();
  if (!token.trim()) return { ok: false, error: 'Missing cloud access token' };

  const base = params.cloudApiBaseUrl.replace(/\/$/, '');
  const url = `${base}/internal/sessions/todos/submit`;
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      sessionId: params.sessionId,
      turnId: params.turnId,
      items: params.items,
    }),
  });

  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as { error?: string } | null;
    return { ok: false, error: body?.error ?? `Planning todo submit failed (${res.status})` };
  }
  return { ok: true };
}
